module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-down-e64b55ea0b0bb7392eb61daa14dc83fa.svg";